/**
 * Re-exports floating-window primitives so dependents (e.g. pathway-frontend) do not need a direct
 * `@nu-art/floating-windows` dependency in their package graph for webpack resolution.
 */
export { ModuleFE_FloatingWindows, windowRect } from '@nu-art/floating-windows';
//# sourceMappingURL=floating-window.js.map